import PropTypes from 'prop-types';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import EnrollInFlowActionMetadata from 'automation-ui-action-features/actions/enroll-in-flow/records/EnrollInFlowActionMetadata';
import EnrollInFlowActionDetail from 'automation-ui-action-features/actions/enroll-in-flow/EnrollInFlowActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
const EnrollInFlowActionHistoryCard = ({
  actionMetadata,
  actionLabel
}) => {
  return /*#__PURE__*/_jsx(LogEventRowAction, {
    title: actionLabel,
    content: /*#__PURE__*/_jsx(EnrollInFlowActionDetail, {
      actionMetadata: actionMetadata
    })
  });
};
EnrollInFlowActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(EnrollInFlowActionMetadata).isRequired,
  actionLabel: PropTypes.node
};
export default EnrollInFlowActionHistoryCard;